export default __webpack_public_path__ + "static/media/bgm-002.7fd1009d.mp3";